// This file exports colors from the TypeScript implementation
import colors from './colors.ts';

export default colors;
